class AccountSignup {
    constructor() {
        this.init();
    }

    init() {
        this.setupEventListeners();
        this.setupPhoneFormatting();
    }

    setupEventListeners() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.onDOMReady());
        } else {
            this.onDOMReady();
        }
    }

    onDOMReady() {
        this.setupPopupHandlers();
        this.setupFormHandlers();
        window.addEventListener('resize', () => this.handleWindowResize());
    }

    setupPopupHandlers() {
        const openButton = document.querySelector("#open-register-popup");
        if (openButton) {
            openButton.addEventListener("click", (e) => {
                e.preventDefault();
                this.showRegisterPopup();
            });
        }

        document.addEventListener("click", (e) => {
            if (e.target.closest(".rewards-join-now-create-account")) {
                e.preventDefault();
                if (window.innerWidth < 768) {
                    window.location.href = "/account/register";
                } else {
                    this.showRegisterPopup();
                }
            }
        });

        const closeButton = document.querySelector("#register-form-close");
        if (closeButton) {
            closeButton.addEventListener("click", (e) => {
                e.preventDefault();
                this.hideRegisterPopup();
            });
        }

        const errorCloseButton = document.querySelector("#register-error-button");
        if (errorCloseButton) {
            errorCloseButton.addEventListener("click", () => {
                window.location.href = window.shopifyRoutes?.account_register_url || "/account/register";
            });
        }

        document.addEventListener("click", (e) => this.handleOutsideClick(e));

        const toggleSignInButton = document.querySelector("#toggle-sign-in-popup");
        if (toggleSignInButton) {
            toggleSignInButton.addEventListener("click", () => {
                this.hideRegisterPopup();
                const signInButton = document.querySelector("#open-signin-popup");
                if (signInButton) signInButton.click();
            });
        }
    }

    setupFormHandlers() {
        const form = document.querySelector("form#createaccount");
        if (form) {
            form.addEventListener("submit", (e) => this.handleFormSubmit(e));
        }

        const activateButton = document.querySelector("#activateMember");
        if (activateButton) {
            activateButton.addEventListener("click", () => {
            });
        }
    }

    setupPhoneFormatting() {
        const phoneInput = document.getElementById("phone");
        if (!phoneInput) return;

        const isSpecialKey = (e) => {
            const keyCode = e.keyCode;
            return e.shiftKey ||
                   keyCode === 35 || keyCode === 36 || keyCode === 8 ||
                   keyCode === 9 || keyCode === 13 || keyCode === 46 ||
                   (keyCode > 36 && keyCode < 41) ||
                   (e.ctrlKey || e.metaKey) &&
                   (keyCode === 65 || keyCode === 67 || keyCode === 86 ||
                    keyCode === 88 || keyCode === 90);
        };

        phoneInput.addEventListener("keydown", (e) => {
            const keyCode = e.keyCode;
            if (!((keyCode >= 48 && keyCode <= 57) ||
                  (keyCode >= 96 && keyCode <= 105) ||
                  isSpecialKey(e))) {
                e.preventDefault();
            }
        });

        phoneInput.addEventListener("keyup", (e) => {
            if (!isSpecialKey(e)) {
                const value = e.target.value.replace(/\D/g, "").substring(0, 10);
                const area = value.substring(0, 3);
                const prefix = value.substring(3, 6);
                const line = value.substring(6, 10);

                if (value.length > 6) {
                    e.target.value = `(${area}) ${prefix}-${line}`;
                } else if (value.length > 3) {
                    e.target.value = `(${area}) ${prefix}`;
                } else if (value.length > 0) {
                    e.target.value = `(${area}`;
                }
            }
        });
    }

    showRegisterPopup() {
        const popup = document.querySelector("#shopify-section-new-account-signup");
        const backgroundSetting = document.querySelector(".account-signup-background-setting");

        if (popup) {
            popup.style.cssText = "display: flex; position: fixed; top: 0px; left: 0px; width: 100%; height: 100%; z-index: 99999; background: rgba(0, 0, 0, 0.5); justify-content: center; align-items: center;";
        }

        if (backgroundSetting) {
            backgroundSetting.classList.add("account-signup-background--active");
        }
    }

    hideRegisterPopup() {
        const popup = document.querySelector("#shopify-section-new-account-signup");
        const backgroundSetting = document.querySelector(".account-signup-background-setting");

        if (popup) {
            popup.style.cssText = "";
        }

        if (backgroundSetting) {
            backgroundSetting.classList.remove("account-signup-background--active");
        }
    }

    handleOutsideClick(e) {
        const backgroundSetting = document.querySelector(".account-signup-background-setting");
        const openButton = document.querySelector("#open-register-popup");
        const isRegisterTrigger = openButton?.contains(e.target) || e.target.closest(".rewards-join-now-create-account");

        if (backgroundSetting) {
            if (!backgroundSetting.contains(e.target) && !isRegisterTrigger) {
                this.hideRegisterPopup();
            }
        }
    }

    handleWindowResize() {
        this.hideRegisterPopup();
    }

    handleFormSubmit(e) {
        e.preventDefault();

        if (this.validateAllInputs()) {
            const formData = this.getFormData();
            this.submitRegistration(formData);
        }
    }

    validateAllInputs() {
        const validations = [
            this.validateName('first_name'),
            this.validateName('last_name'),
            this.validateEmail(),
            this.validatePassword(),
            this.validatePasswordConfirmation(),
            this.validatePhone(),
            this.validateTerms()
        ];

        return validations.every(validation => validation);
    }

    validateName(inputId) {
        const input = document.querySelector(`#createaccount #${inputId}`);
        const nameRegex = /^(?=.{1,1000}$)[a-z]+(?:['_.\s][a-z]+)*$/i;

        if (!input) return false;

        const isValid = input.value.match(nameRegex);
        const errorElement = document.querySelector(`.failed-validation-message .${inputId}`);

        if (errorElement) {
            if (!isValid) {
                errorElement.classList.remove('not-visible');
            } else {
                errorElement.classList.add('not-visible');
            }
        }

        return isValid;
    }

    validateEmail() {
        const email = document.querySelector('#createaccount #email');
        const emailRegex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        if (!email) return false;

        const isValid = email.value.match(emailRegex);
        const errorElement = document.querySelector('.failed-validation-message .email');

        if (errorElement) {
            if (!isValid) {
                errorElement.classList.remove('not-visible');
            } else {
                errorElement.classList.add('not-visible');
            }
        }

        return isValid;
    }

    validatePassword() {
        const password = document.querySelector('#createaccount #password');
        const passwordRegex = /^((?=.*[a-z])(?=.*[A-Z]).{6,})/;

        if (!password) return false;

        const isValid = password.value.match(passwordRegex);
        const errorElement = document.querySelector('.failed-validation-message .password');

        if (errorElement) {
            if (!isValid) {
                errorElement.classList.remove('not-visible');
            } else {
                errorElement.classList.add('not-visible');
            }
        }

        return isValid;
    }

    validatePasswordConfirmation() {
        const password = document.querySelector('#createaccount #password');
        const passwordConfirmation = document.querySelector('#createaccount #password_confirmation');

        if (!password || !passwordConfirmation) return false;

        const isValid = passwordConfirmation.value === password.value;
        const errorElement = document.querySelector('.failed-validation-message .password_confirmation');

        if (errorElement) {
            if (!isValid) {
                errorElement.classList.remove('not-visible');
            } else {
                errorElement.classList.add('not-visible');
            }
        }

        return isValid;
    }

    validatePhone() {
        const phone = document.querySelector('#createaccount #phone');

        if (!phone) return false;

        const isValid = phone.value.length >= 10;
        const errorElement = document.querySelector('.failed-validation-message .phone');

        if (errorElement) {
            if (!isValid) {
                errorElement.classList.remove('not-visible');
            } else {
                errorElement.classList.add('not-visible');
            }
        }

        return isValid;
    }

    validateTerms() {
        const terms = document.querySelector('#createaccount #terms');

        if (!terms) return false;

        const isValid = terms.checked;
        const errorElement = document.querySelector('.failed-validation-message .terms');

        if (errorElement) {
            if (!isValid) {
                errorElement.classList.remove('not-visible');
            } else {
                errorElement.classList.add('not-visible');
            }
        }

        return isValid;
    }

    getFormData() {
        const email = document.querySelector("#email")?.value || '';
        const password = document.querySelector("#password")?.value || '';
        const passwordConfirmation = document.querySelector("#password_confirmation")?.value || '';
        const firstName = document.querySelector("#first_name")?.value || '';
        const lastName = document.querySelector("#last_name")?.value || '';
        let phone = document.querySelector("#phone")?.value.replace(/[()\s-]/g, "") || '';
        if (phone && !phone.startsWith('+1')) {
          phone = '+1' + phone;
        }
        const zip = document.querySelector("#zip")?.value || '';
        const accept_email_marketing = document.querySelector("#input_accept_email_marketing")?.checked || false;
        const accept_sms_marketing = document.querySelector("#input_accept_sms_marketing")?.checked || false;

        return {
            email,
            password,
            password_confirmation: passwordConfirmation,
            first_name: firstName,
            last_name: lastName,
            phone,
            zip,
            accept_email_marketing,
            accept_sms_marketing,
            is_web: 1
        };
    }

    async submitRegistration(formData) {
        const loadWrap = document.querySelector(".loadwrap");

        try {
            if (loadWrap) loadWrap.style.display = 'block';

            const response = await fetch("https://public-api.wss.stacklabs.app/customers/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (loadWrap) loadWrap.style.display = 'none';

            if (data.success) {
                const successWrap = document.querySelector(".t_wrap");
                if (successWrap) successWrap.style.display = 'block';
            } else if (data.data?.errors?.account_invite) {
                const inviteWrap = document.querySelector(".t_wrap2");
                const emailElement = document.querySelector(".t_wrap2 .aemail");
                if (inviteWrap) inviteWrap.style.display = 'block';
                if (emailElement) emailElement.textContent = data.data.email;
            } else {
                const errorWrap = document.querySelector(".cerror");
                if (errorWrap) errorWrap.style.display = 'block';
            }

        } catch (error) {
            if (loadWrap) loadWrap.style.display = 'none';

            const errorWrap = document.querySelector(".cerror");
            if (errorWrap) errorWrap.style.display = 'block';
        }
    }
}

if (typeof window !== 'undefined') {
    window.AccountSignup = AccountSignup;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            new AccountSignup();
        });
    } else {
        new AccountSignup();
    }
}
